import { IconNameV1 } from 'common/icon/iconV1.js';
import { marineMarkerFavSearchbar } from 'components/map/marker-view/collections/marine-marker/marine-fav-forecast.js';
import { iconForCondition } from 'types/condition.js';
import { MarkerTypeGeneral, MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { getRating } from 'utilities/status/rating.js';
import { getAccessStatus } from 'utilities/status/state-access.js';

export const getFavouriteLocationIcon = (favourite: ILocationSummary): IconNameV1 | undefined => {
  if (favourite.value) {
    switch (favourite.type) {
      case MarkerTypeGeneral.Tidal:
        return 'tides'; // was tides-darl
      case MarkerTypeWaterActivity.Boating: {
        const { rating } = favourite.value;
        return `${favourite.type.toLowerCase()}-${getRating(rating).icon}` as IconNameV1;
      }
      case MarkerTypeWaterActivity.Surfing: {
        // The surfing icon is actually named surf.
        const { rating } = favourite.value;
        return `surf-${getRating(rating).icon}` as IconNameV1;
      }
      case MarkerTypeWaterActivity.Kayak:
      case MarkerTypeWaterActivity.Paddleboarding: {
        return marineMarkerFavSearchbar(favourite.type, favourite.value);
      }
      case MarkerTypeGeneral.Ski: {
        const { status, condition } = favourite.value;
        if (status !== undefined && status !== null) {
          return getAccessStatus(status).icon;
        }
        const icon = condition ? iconForCondition(condition) : undefined;
        return icon;
      }
      default:
        const value = favourite.value;
        const icon = 'condition' in value && value.condition ? iconForCondition(value.condition) : undefined;
        return icon;
    }
  }
  return undefined;
};
